import i18next from 'i18next'
import {PayByLinkStatus} from '@/constants'
import {TagType} from '@/components/dumb/Tag/props'
import icons from '~/assets/icons'

export const getPayByLinkPaymentStatusName = (status: PayByLinkStatus): string => {
    switch (status) {
        case PayByLinkStatus.viewed:
            return i18next.t(`enums:payByLinkStatus.active`)
        default:
            return i18next.t(`enums:payByLinkStatus.${status}`, {defaultValue: status})
    }
}

export const getPayByLinkPaymentStatusTagType = (status: PayByLinkStatus): TagType => {
    switch (status) {
        case PayByLinkStatus.attempted:
        case PayByLinkStatus.cancelled:
        case PayByLinkStatus.expired:
            return TagType.Disabled
        case PayByLinkStatus.paid:
            return TagType.Processing
        case PayByLinkStatus.active:
        case PayByLinkStatus.viewed:
            return TagType.Active
        default:
            return TagType.Default
    }
}

export const getPayByLinkPaymentStatusIconType = (status: PayByLinkStatus): keyof typeof icons => {
    switch (status) {
        case PayByLinkStatus.expired:
        case PayByLinkStatus.cancelled:
            return 'close'
        case PayByLinkStatus.paid:
            return 'tick'
        case PayByLinkStatus.viewed:
        case PayByLinkStatus.active:
            return 'dot'
        case PayByLinkStatus.attempted:
            return 'warn'
        default:
            return 'close'
    }
}

export const getPayByLinkPaymentStatusExtraIconType = (
    status: PayByLinkStatus
): keyof typeof icons => {
    switch (status) {
        case PayByLinkStatus.viewed:
            return 'eye'
        default:
            return null
    }
}
